<div class="list-header">
    <p class="list-title">
        <span class="title">{{ (title | async) || "" | translate }}</span>
    </p>

    <div class="search-container">
        <ng-container *ngIf="searchable">
            <input
                   [(ngModel)]="searchTerm"
                   (ngModelChange)="onSearchChange($event)"
                   type="text"
                   class="search-input"
                   [placeholder]="searchPlaceholder || '' | translate"
                   />
            <button (click)="onClearSearch()" class="clear-filter-btn">
                <i class="fa fa-times" aria-hidden="true"></i>
            </button>
        </ng-container>
        <button *ngIf="supervisor && addable" class="plus" (click)="onAddNewItem()">
            <i class="fa fa-plus" aria-hidden="true"></i>
        </button>
        <!-- only on a list opened to pick a value: leaves it without one -->
        <button *ngIf="closable" class="close" type="button" (click)="onClose()"
                [title]="'listHeader.close' | translate"
                [attr.aria-label]="'listHeader.close' | translate">
            <span class="material-icons-outlined">close</span>
        </button>
    </div>
</div>
